module.exports = __webpack_public_path__ + "assets/media/default-avatar.10207647.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/DynamicSchedulingCard/default-avatar.png
// module id = 2600
// module chunks = 0